import React from 'react';

import history from '../../hystory';

interface Props {
  to: string;
  onClick?: (e: any) => void;
  children: any;
}

const Link: React.FC<Props> = ({ children, to, onClick }) => (
  <a
    href={to}
    onClick={e => {
      if (e.defaultPrevented === true) {
        return;
      }
      e.preventDefault();
      history?.push(to);
    }}
  >
    {children}
  </a>
);

export default Link;
